import { client as request } from "./request";

export async function getRokuyo(month: string) {
  return (await request.get("get_rokuyo.php", {
    month
  })) as string[];
}
